// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import MainContent from './components/MainContent'; // Importa el contenido principal
import PaginaDirectora from './pages/PaginaDirectora';
import PaginaCoordinadora from './pages/PaginaCoordinadora';
import PaginaAlumno from './pages/PaginaAlumno';
import PaginaDocente from './pages/PaginaDocente';
import ProtectedRoute from './components/ProtectedRoute';


function App() {
  return (
    <Routes>
      {/* Redirección por defecto a Login */}
      <Route path="/" element={<MainContent />} /> {/* Ruta principal */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Login */}
      <Route path="/login" element={<LoginPage />} />

      {/* Rutas protegidas con comodín para subrutas */}
      <Route
        path="/directora/*"
        element={
          <ProtectedRoute allowedRoles={[1]}>
            <PaginaDirectora />
          </ProtectedRoute>
        }
      />

      <Route
        path="/coordinadora/*"
        element={
          <ProtectedRoute allowedRoles={[2]}>
            <PaginaCoordinadora />
          </ProtectedRoute>
        }
      />

      <Route
        path="/docente/*"
        element={
          <ProtectedRoute allowedRoles={[3]}>
            <PaginaDocente />
          </ProtectedRoute>
        }
      />

      <Route
        path="/alumno/*"
        element={
          <ProtectedRoute allowedRoles={[4]}>
            <PaginaAlumno />
          </ProtectedRoute>
        }
      />

    </Routes>
  );
}

export default App;
